import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import UserType from 'src/model/user-types'
import { withStyles } from '@material-ui/core/styles'
import { get as getCookie } from 'es-cookie'
import LimitReachedModal from 'src/components/limit-reached-modal'
import LaunchSection from './components/launch-section'
import SuggestedSteps from './components/suggested-steps'
import ResourceCard from './components/resource-card'
import useHomeAction from './hooks/useHomeAction'
import useLaunchProgress from './hooks/useLaunchProgress'
import { RESOURCE_GROUPS, SUGGESTED_STEPS } from './constants'
import styles from './styles'

/**
 * Home: setup guide, suggested steps, knowledge base and stay in touch.
 * Same page for every role; the target pages check permissions.
 */
const Home = ({ classes }) => {
  const steps = useLaunchProgress()
  const { runAction, limitModalOpen, closeLimitModal } = useHomeAction()
  // Not persisted: suggested steps open expanded on every visit.
  const [suggestedCollapsed, setSuggestedCollapsed] = useState(false)
  const me = useSelector(state => state.authentication?.me)
  // AppSumo plans have no Members tab, so no "Invite your team" step.
  const suggestedSteps = UserType.isAppSumoUser(me?.userRoleId)
    ? SUGGESTED_STEPS.filter(step => step.id !== 'invite_team')
    : SUGGESTED_STEPS

  useEffect(() => {
    const redirectUrl = getCookie('redirectUrl')
    if (redirectUrl) {
      window.location.href = redirectUrl
    }
  }, [])

  return (
    <main className={classes.root}>
      <div className={classes.content}>
        <LaunchSection steps={steps} onAction={runAction} />
        <SuggestedSteps
          steps={suggestedSteps}
          collapsed={suggestedCollapsed}
          onToggle={() => setSuggestedCollapsed(value => !value)}
          onAction={runAction}
        />
        <div className={classes.resources}>
          {RESOURCE_GROUPS.map(group => (
            <ResourceCard key={group.id} group={group} onAction={runAction} />
          ))}
        </div>
      </div>

      {limitModalOpen && (
        <LimitReachedModal
          isModalOpen={limitModalOpen}
          handleCloseModal={closeLimitModal}
        />
      )}
    </main>
  )
}

export default withStyles(styles)(Home)
